import { render } from "./questions.vue?vue&type=template&id=3fd8a539&scoped=true"
import script from "./questions.vue?vue&type=script&lang=js"
export * from "./questions.vue?vue&type=script&lang=js"

import "./questions.vue?vue&type=style&index=0&id=3fd8a539&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3fd8a539"]])

export default __exports__